// extracted by mini-css-extract-plugin
export default {"spacer":"Overview_spacer__KGJZQ"};